import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const QuickActions = ({ onActionClick, disabled = false }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const quickActions = [
    {
      id: 'pricing',
      label: 'Get Pricing',
      icon: 'DollarSign',
      message: "I'd like to know about your pricing structure and packages."
    },
    {
      id: 'portfolio',
      label: 'View Portfolio',
      icon: 'Eye',
      message: "Can you show me examples of your previous work and case studies?"
    },
    {
      id: 'consultation',
      label: 'Book Consultation',
      icon: 'Calendar',
      message: "I'd like to schedule a free consultation to discuss my project."
    },
    {
      id: 'technology',
      label: 'Tech Stack',
      icon: 'Code',
      message: "What technologies do you use for web and mobile development?"
    },
    {
      id: 'timeline',
      label: 'Project Timeline',
      icon: 'Clock',
      message: "How long does it typically take to complete a project?"
    },
    {
      id: 'support',
      label: 'Support Options',
      icon: 'HelpCircle',
      message: "What kind of ongoing support and maintenance do you provide?"
    }
  ];

  return (
    <div className="border-t border-border bg-background/50 backdrop-blur-sm">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full p-3 flex items-center justify-between hover:bg-muted/30 transition-colors"
      >
        <h4 className="text-sm font-medium text-text-secondary">Quick Actions</h4>
        <Icon
          name={isExpanded ? "ChevronDown" : "ChevronRight"}
          size={16}
          className="text-text-secondary"
        />
      </button>

      {isExpanded && (
        <div className="px-4 pb-4">
          <div className="grid grid-cols-2 gap-2">
            {quickActions.map((action) => (
              <Button
                key={action.id}
                variant="outline"
                size="sm"
                iconName={action.icon}
                iconPosition="left"
                disabled={disabled}
                onClick={() => onActionClick(action.message)}
                className="justify-start text-xs h-9 border-border/50 hover:border-primary/30 hover:bg-primary/5"
              >
                {action.label}
              </Button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default QuickActions;